// extracted by mini-css-extract-plugin
export default {"time":"Time_time__RRxWE","collaborators":"Time_collaborators__+Mure"};